import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Routes from './routes'
//import {VueApollo} from "vue-apollo";

Vue.config.productionTip = true;

Vue.use(VueRouter);
//Vue.use(VueApollo);


const router = new VueRouter({
      routes: Routes,
      mode: 'history'
});

new Vue({
  router: router,
  render: h => h(App)
  
}).$mount('#app')
